export interface MARKER {
  id: number
  name: string
  imageUrl: string
  s3Url: string
}

export enum MARKER_TYPE {
  SRC_Controller = 1,
  Isolation_Valve = 2,
  Valve_ON = 3,
  Valve_OFF = 4,
  Valve_ERROR = 5,
  Soil_Moisture_Sensor = 6,
  Flow_Sensor = 7,
  Temp_Sensor = 8,
  Custom_Markers = 9,
  Weather_Station = 11,
  Sensor_Station_Error = 12,
  Sensor_Station_Normal = 13,
  Sensor_Station_Reachable = 14,
  Sensor_Station_Waiting = 15,
}
